import React, { memo } from 'react';
import styles from './filterContent.module.scss';

const FilterContent = ({ children, className }) =>
    <div className={`${className} ${styles.content}`}>
        {children}
    </div>

export default memo(FilterContent);